import { render, staticRenderFns } from "./coordinateModal.vue?vue&type=template&id=4e9cde36&"
import script from "./coordinateModal.vue?vue&type=script&lang=js&"
export * from "./coordinateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports